export default class Cookies {

    /**
     * debug and help function
     *
     * @return {string}
     */
    getCookies() {
        return document.cookie;
    }

    /**
     * create or update one cookie
     *
     * @param {string} name : tag of cookie
     * @param {string} value : value of cookie
     *
     * @return {Cookies}
     */
    setCookie(name, value) {
        document.cookie = name + "=" + value;

        return this;
    }


    /**
     * remove cookie
     *
     * @param {string} name : tag of cookie
     *
     * @return {Cookies}
     */
    removeCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
        return this;
    }

    /**
     *  add cookie(s) to element
     *
     * @param {string[]} tags array of name cookies
     * @param {string} element selector
     *
     * @return {Cookies}
     */
    fixCookiesSearch(tags, element) {
        const value = document.cookie;
        const rootLocation = $('body').data('root-location');

        if (!$('.search-ui').length) {
            return this;
        }

        $(element).append('<div class="flex flex-column-sm flex-row-lg fixed bottom-right w-full w-sm-auto background-color-brand border-tl-radius-4w shadow-md-inverted overflow-x-auto z-index-10 pt-4w pb-2w pl-4w pr-2w search-cookies-param"></div>');

        for (let tag in tags) {
            let separator = tags[tag] + '=';
            const parts = value.split(separator);
            if (parts.length === 2) {
                let value = parts.pop().split(';').shift();
                let visible = !(window.location.href.indexOf(tags[tag]) > -1) && window.location.href.indexOf('context') > -1 ? 'hidden' : '';
                $('.search-ui-facet-entry[data-value="' + value + '"]').addClass('active').find('input').prop('checked', true);
                $('.search-cookies-param').append(
                    '<button class="btn sm white-space-nowrap mb-2w mr-2w search-ui-cookie-param ' + visible + '" data-value="' + value + '"' +
                    ' data-root-location="' + rootLocation + '" data-facet-type="' + tags[tag] + '">' +
                    value + '<i class="ri-pencil-line ml-1w mr-0" aria-hidden="true"></i>' +
                    '</button>'
                );
                $('button[data-facet-type="' + tags[tag] + '"]').removeClass('disabled').removeAttr('disabled');
            }
        }

        setTimeout(() => {
            if (!$(element).find('.fixed .btn:not(.hidden)').length) {
                !$(element).find('.fixed').remove();
            }
        }, 10);

        return this;
    }

    /**

     * @param {string[]} tags array of name cookies
     * @param {string} element selector
     */
    static init(tags, element) {
        $(document).ready(() => {
            let cookies = new Cookies();
            cookies.fixCookiesSearch(tags, element);
        });
    }

    /**
     *
     * @param name
     * @return {string}
     */
    static getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    /**
     * create or update one cookie
     *
     * @param {string} name : tag of cookie
     * @param {number} value : value of cookie
     * @param days
     */
    static pushCookie(name,value,days) {
            let expires = "";
            if (days) {
                let date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    /**
     *
     * @param name
     */
    static deleteCookie(name, ) {
        let d = new Date();
        d.setDate(d.getDate() - 1);
        let expires = ";expires=" + d;
        document.cookie = name + "=" + "" + expires + "; path=/";
    }
}
